import React from 'react';
import { Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Logo from './../../../../../../assets/images/logo.png';
import Login from '../../../../../../components/Login'
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { googleLogout } from '@react-oauth/google';
import { revokeGoogleToken, backendApi } from '../../../../../../components/Api';

const SidebarNav = ({ accessToken,userDetailsdata }) => {
  const serverUrl = process.env.REACT_APP_SERVER_URL

  const userDetails = userDetailsdata || ''
  const theme = useTheme();
  const navigate = useNavigate();
  const { mode } = theme.palette;

  const logout = async () => {
    if (userDetails?.email) {
      await backendApi(`${serverUrl}api/auth/logout`, { email: userDetails.email })
    }
    if (accessToken) {
      await revokeGoogleToken(accessToken)
    }
    googleLogout()
    localStorage.clear()
    navigate('/', { state: {} })
  };


  return (
    <Box>
      <Box paddingX={1.5} lineHeight={'0'} className="sidebar-logo">
        <Link
          display={'flex'}
          component="a"
          to="/"
          title="IMWT"
        >
          <Box
            component={'img'}
            src={Logo}
            width={190}
          />
        </Link>
      </Box>
      <Box paddingX={1.5} paddingY={2} marginTop={1}>
        <Box>
        {window.location.pathname === '/analytics-report' ?
        <Box marginBottom={1}>
            <Link 
                className='side-menu-item'
                underline="none"
                component="a"
                to="/"
              >
                Take Another Test
              </Link>
          </Box> : '' }
          <Box>
            <Link 
                className='side-menu-item'
                underline="none"
                component="a"
                to="/contact"
              >
                Contact us
              </Link>
          </Box>
        </Box>
        {!userDetails ?
          <Box className="header-btn" marginTop={2}>
              <Login endIcon={false}/>
          </Box> :
            <Box marginTop={2}>
              <Button className='theme-btn lite-btn' onClick={logout} size="small">Log out</Button>
            </Box> }
      </Box>
    </Box>
  );
};


export default SidebarNav;
